import React from 'react'
import { func, bool, string } from 'prop-types'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import { PagesPaths } from '../../../constants/Pages'

export const GoToDevisButton = withRouter(translate()(({ id, isMaintenance, t, history }) => {
  const page = isMaintenance ? PagesPaths.INQUIRY_MAINTENANCE_DETAIL.path : PagesPaths.INQUIRY_REALISATION_DETAIL.path
  return (
    <button onClick={() => history.push(`${page}/${id}`)} className='btn--green'>{t('common:visits:go_to_devis')}</button>
  )
}))

GoToDevisButton.propTypes = {
  t: func,
  id: string,
  isMaintenance: bool
}



// WEBPACK FOOTER //
// ./src/components/ui/buttons/GoToDevisButton.js